import { en } from './en';

export const pt: Record<string, string> = {
  'delivery.title': "Onde devemos entregar a sua encomenda?",
  'delivery.beforeSignup': "Verifique a disponibilidade de entrega antes de introduzir os seus dados pessoais.",
  'delivery.country': "País de entrega",
  'delivery.choose': "Escolha o país de entrega",
  'delivery.availableTo': "Entrega em:",
  'delivery.blocked': "Alguns artigos não podem ser entregues no país selecionado. O seu carrinho foi mantido. Escolha outro país de entrega ou remova os artigos indisponíveis.",
  'delivery.backToCart': "Voltar ao carrinho",
  'delivery.updateAddress': "Atualizar a morada de entrega",
  'delivery.checkFailed': "Não foi possível verificar a disponibilidade de entrega. O seu carrinho foi mantido. Tente novamente.",
  'delivery.retry': "Tentar novamente",
  'delivery.checking': "A verificar a disponibilidade de entrega…",
  ...en,
  'cart.adding': 'Adicionando...',
  'cart.added': 'Adicionado',
  'cart.addSuccess': 'Produto adicionado ao carrinho',
  'cart.addFail': 'Falha ao adicionar produto: {error}',
  'title.cart': 'Carrinho',
  'title.catalog': 'Catálogo',
  'title.checkout': 'Finalizar compra',
  'title.signup': 'Cadastrar',
  'title.tickets': 'Atendimento',
  'title.discounts': 'Seu desconto pessoal',
  'auth.login': 'Entrar',
  'auth.loginModal.remindPassword': 'Esqueceu a senha?',
  'auth.logout': 'Sair',
  'auth.signup': 'Cadastrar',
  'auth.myAccount': 'Minha conta',
  'auth.orders': 'Meus pedidos',
  'auth.discount': 'Seu desconto pessoal!',
  'discounts.title': 'Seu desconto pessoal',
  'discounts.description': 'Este desconto é aplicado automaticamente a todos os seus pedidos.',
  'auth.bonusAccount': 'Sua conta bônus',
  'auth.referral': 'Programa de indicação',
  'auth.subscriptions': 'Assinaturas',
  'title.subscriptions': 'Assinaturas',
  'subs.loading': 'Carregando...',
  'subs.loginRequired': 'Faça login para gerenciar suas assinaturas.',
  'subs.empty': 'Nenhuma newsletter disponível.',
  'subs.instruction': 'Selecione as newsletters que deseja assinar ou cancelar',
  'subs.list.1.name': 'Descontos em produtos',
  'subs.list.1.descr': 'Descontos em produtos do seu interesse. Frequência – mensal',
  'subs.list.2.name': 'Descontos de aniversário',
  'subs.list.2.descr': 'E-mail de aniversário com presente. Frequência – anual',
  'subs.list.3.name': 'Aviso de reposição',
  'subs.list.3.descr': 'Notificação de reposição. Frequência – a cada 2–3 meses',
  'subs.list.4.name': 'Novidades da loja',
  'subs.list.4.descr': 'Frequência – raramente',
  'subs.success': 'Assinaturas atualizadas',
  'subs.failed': 'Falha ao atualizar.',
  'subs.updating': 'Atualizando...',
  'subs.update': 'Atualizar',
  'inline.loginLink': 'inicie sessao',
  'inline.loginRequiredPrefix': 'Por favor, ',
  'inline.loginRequiredSuffix': ' para ver esta pagina.',
  'inline.subscriptionsAuthRedirect':
    'As subscrições de newsletter estão disponíveis apenas para clientes com sessão iniciada. Inicie sessão para continuar.',
  'subscribe.title': 'Assine para receber ofertas',
  'subscribe.subtitle': 'Receba descontos exclusivos e lembretes de pedidos',
  'subscribe.cta': 'Assinar',
  'subscribe.emailLabel': 'E-mail',
  'subscribe.emailPlaceholder': 'seu@email.com',
  'subscribe.phoneLabel': 'Telefone',
  'subscribe.phonePlaceholder': '+351 900 000 000',
  'subscribe.consentLabel': 'Concordo em receber e-mails promocionais e lembretes de pedidos',
  'subscribe.consentRequired': 'Concorde em receber e-mails',
  'subscribe.invalidEmail': 'Digite um e-mail valido',
  'subscribe.success': 'Obrigado! Voce esta inscrito.',
  'auth.tickets': 'Atendimento',
  'auth.deleteAccount': 'Excluir conta',
  'cartWidget.cart': 'Carrinho',
  'cartWidget.viewCart': 'VER CARRINHO',
  'cartWidget.shoppingCart': 'Carrinho',
  'cartWidget.items': 'itens',
  'title.checkoutQnr': 'Questionário médico',
  'title.checkoutConfirm': 'Confirmação do pedido',
  'cartPage.empty': 'Seu carrinho está vazio',
  'cartPage.product': 'Produto',
  'cartPage.qty': 'Qtd.',
  'cartPage.price': 'Preço',
  'cartPage.lineTotal': 'Total',
  'cartPage.loading': 'Carregando carrinho...',
  'cartPage.startShopping': 'Comecar a comprar',
  'cartPage.recalculate': 'Recalcular',
  'cartPage.remove': 'Remover',
  'cartPage.free': 'Gratis',
  'cartPage.quickNotes': 'Notas rápidas:',
  'cartPage.note1': '1. O seguro de envio garante reembolso ou reenvio.',
  'cartPage.note2': '2. Pagamento com Bitcoin oferece 10% de desconto.',
  'cartPage.note3': '3. Insira um cupom de desconto valido abaixo.',
  'cartPage.note4': '4. Alguns descontos sao ativados apos a selecao do pagamento.',
  'cartPage.couponPlaceholder': 'Insira um cupom aqui',
  'cartPage.couponLabel': 'Codigo do cupom',
  'cartPage.couponSubmit': 'Aplicar',
  'cartPage.couponInvalid': 'O cupom e invalido ou expirou.',
  'cartPage.couponSuccess': 'O cupom foi adicionado com sucesso.',
  'cartPage.couponNotApplied': 'O cupom nao foi aplicado. Ele e invalido, restrito ao metodo de pagamento selecionado ou nao atende aos requisitos da promocao.',
  'cartPage.couponCleared': 'O cupom foi removido.',
  'cartPage.itemRemoved': 'Item removido do carrinho.',
  'cartPage.removeFailed': 'Falha ao remover item.',
  'cartPage.updateQtyFailed': 'Falha ao atualizar a quantidade.',
  'cartPage.qtyDecrease': 'Diminuir quantidade',
  'cartPage.qtyIncrease': 'Aumentar quantidade',
  'cartPage.maxPillsHint': 'Máx. {pills} comprimidos ({packs} packs)',
  'cartPage.deliveryMethod': 'Metodo de entrega:',
  'cartPage.standard': 'Padrao',
  'cartPage.subtotal': 'Subtotal:',
  'cartPage.personalDiscount': 'Desconto pessoal:',
  'cartPage.bonusDiscount': 'Desconto de bonus:',
  'cartPage.discountCoupon': 'Cupom de desconto:',
  'cartPage.clearCoupon': 'Remover cupom',
  'cartPage.shippingCost': 'Custo de envio:',
  'cartPage.discounted': 'com desconto',
  'cartPage.freeShipping': 'envio gratis',
  'cartPage.shippingInsurance': 'Seguro de envio:',
  'cartPage.backToShopping': 'Voltar as compras',
  'shippingMethod.airmail_service': 'Servico de correio aereo',
  'cartPage.total': 'Total:',
  'cartPage.checkout': 'Finalizar compra',
  'stepper.cart': 'Carrinho',
  'stepper.payment': 'Pagamento',
  'stepper.medical': 'Médico',
  'stepper.confirm': 'Confirmar',
  'miniCart.subtotal': 'Subtotal:',
  'miniCart.personalDiscount': 'Desconto pessoal:',
  'miniCart.bonusDiscount': 'Desconto de bonus:',
  'miniCart.discountCoupon': 'Cupom de desconto:',
  'miniCart.shippingCost': 'Custo de envio:',
  'miniCart.freeShipping': 'envio gratis',
  'miniCart.shippingInsurance': 'Seguro de envio:',
  'miniCart.total': 'Total:',
  'miniCart.editCart': 'Editar carrinho',
  'checkout.continue': 'Continuar',
  'confirm.title': 'Confirmação do pedido',
  'confirm.placeOrder': 'Fazer pedido',
  'qnr.title': 'Questionário médico',
  'confirm.retentionConsent': 'Concordo em receber e-mails promocionais e lembretes sobre meus pedidos',
  'profile.updateProfile': 'Atualizar perfil',
  'telegram.title': 'Notificações do Telegram',
  'telegram.hint': 'Conecte o Telegram para receber atualizações de pedidos, alertas de rastreamento e chat de suporte no telefone.',
  'telegram.orderFcTitle': 'Confirme o pedido pelo Telegram',
  'telegram.orderFcIntro': 'Este pedido requer uma confirmação rápida dos seus dados antes de enviarmos as instruções de pagamento.',
  'telegram.orderFcFastest': 'Opção mais rápida: conecte o Telegram abaixo. Após o pedido, o bot enviará uma solicitação de confirmação.',
  'telegram.orderFcAlternatively': 'Alternativamente: confirme por telefone ou',
  'telegram.liveChat': 'chat ao vivo',
  'telegram.orderFcReady': 'Podemos enviar a solicitação de confirmação para o seu Telegram. Verifique o chat do bot.',
  'telegram.orderInfoTitle': 'Receba atualizações no Telegram',
  'telegram.orderInfoIntro': 'Conecte nosso bot de suporte para:',
  'telegram.orderInfoItem1': 'Status do pedido e atualizações de envio',
  'telegram.orderInfoItem2': 'Eventos de rastreamento e alertas de entrega',
  'telegram.orderInfoItem3': 'Lembretes de pagamento quando necessário',
  'telegram.orderInfoItem4': 'Chat direto com o suporte pelo telefone',
  'telegram.statusLoading': 'Verificando conexão do Telegram…',
  'telegram.unavailable': 'A conexão do Telegram não está disponível no momento.',
  'telegram.connected': 'Telegram conectado',
  'telegram.connectedAt': 'Conectado',
  'telegram.boundFrom': 'Conectado de',
  'telegram.connect': 'Conectar Telegram',
  'telegram.connecting': 'Conectando…',
  'telegram.linkReady': 'Abra o Telegram e toque em Start para terminar de vincular sua conta.',
  'telegram.openTelegram': 'Abrir Telegram',
  'telegram.copyLink': 'Copiar link',
  'telegram.copied': 'Copiado',
  'telegram.expiresMinutes': 'O link expira em cerca de {minutes} minutos.',
  'telegram.notificationsTitle': 'Preferências de notificação',
  'telegram.notificationsHint': 'A confirmação do pedido e o chat de suporte sempre funcionam. Escolha os alertas opcionais abaixo.',
  'telegram.notificationsSaving': 'Salvando…',
  'telegram.notificationsSaveError': 'Não foi possível salvar as configurações de notificação.',
  'telegram.disconnect': 'Desconectar Telegram',
  'telegram.disconnectConfirm': 'Desconectar o Telegram da sua conta? Você poderá conectá-lo novamente nesta página.',
  'telegram.disconnectYes': 'Sim, desconectar',
  'telegram.disconnectCancel': 'Cancelar',
  'telegram.coupon.checkoutTitle': 'Conecte o Telegram e poupe 20%',
  'telegram.coupon.checkoutBody': 'Conecte agora e aplicaremos 20% a esta encomenda.',
  'telegram.coupon.checkoutAction': 'Conectar Telegram e aplicar 20%',
  'telegram.coupon.applied': 'Telegram conectado — o seu desconto de 20% foi aplicado.',
  'telegram.coupon.replaceConfirm': 'Substituir o cupão atual e aplicar 20%',
  'telegram.coupon.active': 'Cupão Telegram de {percent}% disponível.',
  'telegram.coupon.redeemed': 'Cupão Telegram utilizado.',
  'telegram.coupon.expired': 'O cupão Telegram expirou.',
  'telegram.disconnectError': 'Não foi possível desconectar o Telegram.',
  'telegram.pref.order_status.label': 'Atualizações de status do pedido',
  'telegram.pref.order_status.description': 'Processamento, cancelamento, recusa e outras alterações de status.',
  'telegram.pref.shipped.label': 'Envio e números de rastreamento',
  'telegram.pref.shipped.description': 'Quando seu pedido for enviado ou reenviado com um número de rastreamento.',
  'telegram.pref.tracking_updates.label': 'Eventos de rastreamento da entrega',
  'telegram.pref.tracking_updates.description': 'Atualizações da transportadora, como em trânsito, saiu para entrega ou entregue.',
  'telegram.pref.payment.label': 'Lembretes de pagamento',
  'telegram.pref.payment.description': 'Instruções de pagamento e avisos de pagamento insuficiente.',
  'telegram.pref.promotions.label': 'Promoções e ofertas',
  'telegram.pref.promotions.description': 'Descontos opcionais e ofertas especiais.',
  'signup.createAccount': 'Criar conta',
  'login.title': 'Entrar',
  'login.loginLabel': 'Login',
  'login.loginPlaceholder': 'E-mail ou nome de usuario',
  'login.passwordLabel': 'Senha',
  'login.loginRequired': 'Login e obrigatorio',
  'login.passwordRequired': 'Senha e obrigatoria',
  'login.invalidCredentials': 'E-mail ou senha invalidos.',
  'login.noAccount': 'Nao tem conta?',
  'login.signupLink': 'Cadastre-se',
  'login.submit': 'Entrar',
  'signup.personalInfo': 'Informacoes pessoais',
  'signup.title': 'Titulo',
  'signup.mr': 'Sr.',
  'signup.mrs': 'Sra.',
  'signup.ms': 'Sra.',
  'signup.firstName': 'Nome',
  'signup.lastName': 'Sobrenome',
  'signup.contactInfo': 'Informacoes de contato',
  'signup.email': 'E-mail',
  'signup.phone': 'Telefone',
  'signup.billingAddress': 'Endereco de cobranca',
  'signup.address': 'Endereco',
  'signup.zipcode': 'CEP',
  'signup.city': 'Cidade',
  'signup.country': 'Pais',
  'signup.state': 'Estado',
  'signup.selectCountry': 'Selecionar pais',
  'signup.stateProvince': 'Estado / Provincia',
  'signup.selectState': 'Selecionar estado',
  'signup.shippingAddress': 'Endereco de entrega',
  'signup.sameAsBilling': 'Mesmo endereco de cobranca',
  'signup.privacyInfo': 'Informacoes de privacidade',
  'signup.password': 'Senha',
  'signup.passwordHint': 'Minimo de 5 caracteres. Deve ser diferente do usuario.',
  'signup.confirmPassword': 'Confirmar senha',
  'signup.agreeTermsTemplate': 'Concordo com os {terms} da empresa.',
  'signup.agreeTermsLink': 'Termos e condicoes',
  'signup.firstNameRequired': 'Nome e obrigatorio',
  'signup.lastNameRequired': 'Sobrenome e obrigatorio',
  'signup.emailRequired': 'E-mail e obrigatorio',
  'signup.emailInvalid': 'Formato de e-mail invalido',
  'signup.phoneRequired': 'Telefone e obrigatorio',
  'signup.addressRequired': 'Endereco e obrigatorio',
  'signup.zipcodeRequired': 'CEP e obrigatorio',
  'signup.cityRequired': 'Cidade e obrigatoria',
  'signup.countryRequired': 'Pais e obrigatorio',
  'signup.passwordRequired': 'Senha e obrigatoria',
  'signup.passwordMinLength': 'A senha deve ter pelo menos 5 caracteres',
  'signup.passwordMismatch': 'As senhas nao coincidem',
  'signup.termsRequired': 'Voce deve aceitar os Termos e Condicoes',
  'signup.failed': 'Falha no cadastro',
  'signup.creating': 'Criando conta...',
  'forgotPassword.emailLabel': 'E-mail',
  'forgotPassword.emailPlaceholder': 'voce@exemplo.com',
  'forgotPassword.submit': 'Enviar codigo',
  'forgotPassword.success': 'Enviamos um codigo de 10 caracteres para seu e-mail.',
  'forgotPassword.successHint': 'Digite o codigo na proxima pagina para definir uma nova senha.',
  'forgotPassword.goToSetPassword': 'Inserir codigo e definir senha',
  'forgotPassword.backToLogin': 'Voltar ao login',
  'forgotPassword.invalidEmail': 'Digite um e-mail valido',
  'resetPassword.emailLabel': 'E-mail',
  'resetPassword.resetCodeLabel': 'Codigo do e-mail',
  'resetPassword.resetCodePlaceholder': '10 caracteres',
  'resetPassword.resetCodeFormat': 'O codigo deve ter exatamente 10 letras ou numeros',
  'resetPassword.newPasswordLabel': 'Nova senha',
  'resetPassword.confirmLabel': 'Confirmar senha',
  'resetPassword.passwordPlaceholder': '••••••••',
  'resetPassword.passwordMin': 'A senha deve ter pelo menos 5 caracteres',
  'resetPassword.passwordMismatch': 'As senhas nao coincidem',
  'resetPassword.submit': 'Salvar',
  'resetPassword.success': 'Senha atualizada. Agora voce pode entrar.',
  'resetPassword.redirectHint': 'Redirecionando...',
  'orders.title': 'Meus pedidos',
  'tickets.newMessage': 'Mensagem',
  'tickets.newUpload': 'Enviar arquivos (PDF, JPG, PNG, TXT)',
  'contact.formTitle': 'Envie uma mensagem',
  'contact.loginRequired': 'Faca login para enviar um ticket de suporte.',
  'testimonials.customer': 'Cliente',
  'testimonials.loading': 'Carregando depoimentos...',
  'testimonials.empty': 'Ainda nao ha depoimentos.',
  'testimonials.loadError': 'Nao foi possivel carregar os depoimentos. Tente novamente mais tarde.',
  'testimonials.formTitle': 'Deixar um depoimento',
  'testimonials.namePlaceholder': 'Seu nome',
  'testimonials.messagePlaceholder': 'Sua avaliacao',
  'testimonials.submitting': 'Enviando...',
  'testimonials.submit': 'Enviar avaliacao',
  'testimonials.submitError': 'Nao foi possivel enviar o depoimento.',
  'testimonials.loginRequired': 'Faca login para deixar um depoimento.',
  'testimonials.validationName': 'O nome deve ter pelo menos 2 caracteres.',
  'testimonials.validationMessage': 'A avaliacao deve ter pelo menos 6 caracteres.',
  'testimonials.success': 'Obrigado pela sua avaliacao! Ela aparecera apos a moderacao.',
  'contact.requestFrom': 'Solicitacao sera enviada por',
  'contact.unknownUser': 'Usuario autenticado',
  'contact.subject': 'Assunto',
  'contact.subjectPlaceholder': 'Como podemos ajudar?',
  'contact.message': 'Mensagem',
  'contact.messagePlaceholder': 'Descreva seu problema...',
  'contact.send': 'Enviar mensagem',
  'contact.ticketsLoginRequired': 'Entre para ver e enviar tickets de suporte.',
  'chat.online': 'Online',
  'chat.offline': 'Offline',
  'chat.coming_soon': 'O chat ao vivo esta sendo configurado. Por enquanto, use e-mail ou telefone.',
  'chat.offline_message': 'Nossos operadores estao offline no momento.',
  'chat.leave_message': 'Deixe uma mensagem e retornaremos.',
  'chat.leave_ticket': 'Deixar um ticket',
  'nav.login': 'Entrar',
  'nav.signup': 'Criar conta',
  'miniCart.deliveryMethod': 'Metodo de entrega',
  'month.1': 'Janeiro', 'month.2': 'Fevereiro', 'month.3': 'Marco',
  'month.4': 'Abril', 'month.5': 'Maio', 'month.6': 'Junho',
  'month.7': 'Julho', 'month.8': 'Agosto', 'month.9': 'Setembro',
  'month.10': 'Outubro', 'month.11': 'Novembro', 'month.12': 'Dezembro',
  'checkout.accountHint': 'Numero da conta - Geralmente vem antes do numero do cheque; a localizacao varia.',
  'checkout.accountNumber': 'Numero de conta',
  'checkout.authLogin': 'Entrar',
  'checkout.authPrompt': 'Faca login ou registre-se para continuar a compra.',
  'checkout.authSignup': 'Cadastre-se',
  'checkout.backToConfirm': 'Voltar a confirmacao do pedido',
  'checkout.backToShop': 'Voltar a loja',
  'checkout.bankName': 'Nome do banco',
  'checkout.btcStep1': "Conclua o pedido para abrir a página de pagamento.",
  'checkout.btcStep2': "Envie o montante exato em BTC para o endereço indicado, usando a rede especificada.",
  'checkout.btcStep3': "Pague antes de os dados de pagamento expirarem.",
  'checkout.btcOrderNote': "Use estes dados de pagamento apenas para este pedido. Não é necessária confirmação por telefone.",
  'checkout.btcHelp': "Como comprar Bitcoin",
  "checkout.cryptoTitle": "Pagar com criptomoedas",
  "checkout.cryptoStep1": "Clique em Continuar.",
  "checkout.cryptoStep2": "Escolha a moeda e a rede na página seguinte.",
  "checkout.cryptoStep3": "Siga as instruções para concluir o pagamento.",
  "checkout.cryptoCoinsLabel": "Moedas disponíveis",
  "checkout.cryptoCoins": "Ethereum · Litecoin · Bitcoin Cash · Dogecoin · Monero · Tron · XRP · Cardano · TON · BNB",
  "checkout.cryptoNetworks": "Escolha Ethereum (ERC-20), Tron (TRC-20) ou BNB Smart Chain (BEP-20).",
  "checkout.cryptoBitcoinTitle": "Quer pagar com Bitcoin (BTC)?",
  "checkout.cryptoBitcoinNote": "Selecione a opção de pagamento Bitcoin separada no checkout.",
  'checkout.btcTitle': "Pagar com Bitcoin",
  'checkout.cartEmpty': 'Seu carrinho esta vazio.',
  'checkout.ccNumber': 'Numero do cartao de credito (sem espacos ou tracos)',
  'checkout.ccType': 'Tipo de cartao de credito',
  'checkout.checkNumber': 'Numero do cheque',
  'checkout.cvv': 'CVV2',
  'checkout.error': 'Ocorreu um erro',
  'checkout.expDate': 'Data de validade',
  'checkout.loading': 'Carregando finalizacao da compra...',
  'checkout.noPayments': 'Infelizmente, nenhum pagamento esta disponivel para finalizacao da compra. Entre em contato com o departamento de vendas ou suporte.',
  'checkout.paymentFailed': 'Falha ao definir a forma de pagamento',
  'checkout.processing': 'Processando...',
  'checkout.routingHint': 'Numero de roteamento (codigo ABA) - Geralmente 9 digitos em seu cheque.',
  'checkout.routingNumber': 'Numero de roteamento (codigo ABA)',
  'checkout.selectPayment': 'Selecione um metodo de pagamento',
  'contact.email': 'E-mail',
  'contact.hours': 'Horas de trabalho',
  'contact.previewHours': 'Seg-Sex 9:00-18:00',
  'contact.support247': 'Suporte 24/7',
  'contact.live_chat': 'Bate-papo ao vivo',
  'contact.open_ticket': 'Abrir um ticket',
  'contact.phone': 'Telefone',
  'contact.start_chat': 'Iniciar bate-papo',
  'contact.tickets_desc': 'Tem alguma pergunta? Abra um ticket de suporte e entraremos em contato com voce.',
  'contact.title': 'Contate-nos',
  'contact.unavailable': 'As informacoes de contato nao estao disponiveis.',
  'deleteAccount.attention': 'Atencao!',
  'deleteAccount.failed': 'Falha na solicitacao. Por favor, tente novamente.',
  'deleteAccount.password': 'Senha',
  'deleteAccount.passwordRequired': 'A senha e obrigatoria.',
  'deleteAccount.reason': 'Razao',
  'deleteAccount.reasonHint': 'Por favor, compartilhe seu motivo para sair. Seu feedback nos ajuda a melhorar.',
  'deleteAccount.reasonRequired': 'A razao e necessaria.',
  'deleteAccount.rule1': 'Voce nao deve ter nenhum estorno em seu historico.',
  'deleteAccount.rule2': 'Devem decorrer pelo menos 21 dias apos o seu ultimo pedido bem-sucedido.',
  'deleteAccount.rules': 'Regras de exclusao de conta:',
  'deleteAccount.safetyInfo': 'Sua privacidade e importante para nos. Voce pode excluir permanentemente sua conta e historico relacionado a qualquer momento.',
  'deleteAccount.submit': 'Enviar',
  'deleteAccount.success': 'Conta excluida com sucesso.',
  'deleteAccount.thanks': 'Obrigado por escolher nosso servico.',
  'deleteAccount.warning': 'Se um estorno for recebido posteriormente para qualquer pedido, sua conta podera ser restaurada para processar esse caso. Em caso de duvidas, entre em contato com o suporte 24 horas por dia, 7 dias por semana.',
  'profile.address': 'Endereco',
  'profile.addressRequired': 'O endereco e obrigatorio',
  'profile.billingAddress': 'Endereco de cobranca',
  'profile.changePassword': 'Alterar a senha',
  'profile.city': 'Cidade',
  'profile.cityRequired': 'A cidade e obrigatoria',
  'profile.confirmPassword': 'Confirme sua senha',
  'profile.country': 'Pais',
  'profile.countryRequired': 'O pais e obrigatorio',
  'profile.email': 'E-mail',
  'profile.emailInvalid': 'Formato de e-mail invalido',
  'profile.emailRequired': 'O e-mail e obrigatorio',
  'profile.firstName': 'Primeiro nome',
  'profile.firstNameRequired': 'O primeiro nome e obrigatorio',
  'profile.lastName': 'Sobrenome',
  'profile.lastNameRequired': 'O sobrenome e obrigatorio',
  'profile.loadFailed': 'Falha ao carregar dados do perfil',
  'profile.loading': 'Carregando perfil...',
  'profile.mr': 'Senhor.',
  'profile.mrs': 'Sra.',
  'profile.ms': 'Sra.',
  'profile.newPassword': 'Nova senha',
  'profile.passwordHint': 'Deixe em branco se nao quiser alterar sua senha.',
  'profile.passwordMinLength': 'A senha deve ter pelo menos 5 caracteres',
  'profile.passwordMismatch': 'As senhas nao coincidem',
  'profile.personalInfo': 'Informacoes pessoais',
  'profile.phone': 'Telefone',
  'profile.phoneRequired': 'O telefone e obrigatorio',
  'profile.sameAsBilling': 'Igual ao endereco de cobranca',
  'profile.saving': 'Salvando...',
  'profile.selectCountry': 'Selecione o pais',
  'profile.selectState': 'Selecione o estado',
  'profile.shippingAddress': 'Endereco para envio',
  'profile.state': 'Estado',
  'profile.stateProvince': 'Estado/Provincia',
  'profile.title': 'Titulo',
  'profile.updateFailed': 'Falha na atualizacao',
  'profile.updateSuccess': 'Perfil atualizado com sucesso',
  'profile.zipcode': 'CEP',
  'profile.zipcodeRequired': 'O CEP e obrigatorio',
  'select.noResults': 'Nenhum resultado encontrado',
  'select.placeholder': 'Selecione...',
  'select.search': 'Procurar...',
  'tickets.activationFailed': 'Falha ao enviar e-mail de ativacao',
  'tickets.activationSuccess': 'E-mail de ativacao enviado com sucesso',
  'tickets.authInstructions': 'Se desejar ativa-lo, clique no botao abaixo e enviaremos as instrucoes por e-mail.',
  'tickets.authNotActivated': 'O sistema de tickets ainda nao foi ativado para sua conta.',
  'tickets.backToTickets': 'Voltar para tickets',
  'tickets.createSuccess': 'Ticket criado com sucesso',
  'tickets.date': 'Data',
  'tickets.dateLabel': 'Data:',
  'tickets.detailLoading': 'Carregando ticket...',
  'tickets.empty': 'Nenhum ticket encontrado no momento. Use \"Abrir novo ticket\" para fazer uma pergunta',
  'tickets.fileLimit': 'Selecione ate 3 arquivos.',
  'tickets.lastReply': 'Ultima resposta',
  'tickets.loading': 'Carregando tickets...',
  'tickets.loadingMore': 'Carregando mais...',
  'tickets.message': 'Mensagem',
  'tickets.newSubject': 'Assunto',
  'tickets.newTicketTitle': 'Abrir novo ticket',
  'tickets.noMessages': 'Nenhuma mensagem encontrada.',
  'tickets.messagesHeading': 'Mensagens',
  'tickets.messageFromSupport': 'Suporte',
  'tickets.messageFromYou': 'Você',
  'tickets.replyHeading': 'Responder',
  'tickets.attachFiles': 'Anexar ficheiros',
  'tickets.filesCount': '{count} arquivo(s)',
  'tickets.notActivated': 'Sistema de tickets nao ativado para sua conta.',
  'tickets.openNew': 'Abrir novo ticket',
  'tickets.refresh': 'Atualizar',
  'tickets.resolve': 'Resolver ticket',
  'tickets.resolveConfirm': 'Tem certeza de que deseja resolver este ticket?',
  'tickets.sendActivation': 'Enviar e-mail de ativacao',
  'tickets.sendReply': 'Enviar resposta',
  'tickets.status': 'Status',
  'tickets.statusAwaitingAgent': 'Aguardando agente',
  'tickets.statusAwaitingUser': 'Aguardando usuario',
  'tickets.statusLabel': 'Status:',
  'tickets.statusPending': 'Pendente',
  'tickets.statusResolved': 'Resolvido',
  'tickets.subject': 'Assunto',
  'tickets.submitTicket': 'Enviar o ticket',
  'tickets.title': 'Tickets de suporte',
  'tickets.uploadFiles': 'Carregar arquivos (PDF, JPG, PNG, TXT)',
  'close': 'Fechar',
  'loading': 'Carregando...',
  'yes': 'Sim',
  'no': 'Não',
  'tickets.unavailable': 'Os tickets de suporte estão temporariamente indisponíveis. Tente novamente mais tarde ou entre em contato com o suporte por e-mail se for urgente.',
  'api.genericError': 'Ocorreu um erro. Tente novamente mais tarde.',
  'api.networkError': 'Serviço temporariamente indisponível. Verifique sua conexão.',
  'api.error.10503': 'Serviço indisponível',
  'api.error.40001': 'A autenticação do cliente falhou',
  'api.error.40004': 'A validação dos dados do cliente falhou',
  'api.error.40008': 'Este login já existe',
  'api.error.40009': 'Este e-mail já existe',
  'api.error.40021': 'A conta do cliente já existe',
  'api.error.40022': 'Cliente não encontrado',
  'api.error.400014': 'O cupom é inválido',
  'api.error.50001': 'A verificação de fraude falhou',
  'api.error.50002': 'A conta tem pedidos em aberto e não pode ser excluída.',
  'api.error.60001': 'Este produto está indisponível no momento.',
  'geo.soft_notice': 'This product has delivery region limits. Final availability is confirmed after sign-in using your shipping address.',
  'api.error.60101': 'Pode adicionar até {limit} produtos diferentes por encomenda.',
  'api.error.60102': 'A quantidade máxima para este produto é {limit}.',
  'api.error.60103': 'O número máximo de packs para este produto é {limit}.',
  'unsubscribe.processing': 'A processar…',
  'unsubscribe.success': 'Foi removido dos e-mails de marketing de {shop_name}.',
  'unsubscribe.shop': 'Loja',
  'unsubscribe.invalidLink': 'Link inválido ou expirado.',
  'unsubscribe.error': 'Ocorreu um erro.',

  'title.orderReturn': 'Estado do pagamento',
  'orderReturn.successTitle': 'Obrigado!',
  'orderReturn.successLead': 'O seu pagamento foi recebido.',
  'orderReturn.successHint': 'Enviámos um e-mail de confirmação. As atualizações de envio chegarão em breve.',
  'orderReturn.cancelTitle': 'Pagamento cancelado',
  'orderReturn.cancelLead': 'Não foi efetuado qualquer pagamento neste pedido.',
  'orderReturn.cancelHint': 'Após o checkout o carrinho fica vazio. Use os detalhes do pedido ou « Tentar novamente » abaixo.',
  'orderReturn.failureTitle': 'Pagamento falhado',
  'orderReturn.failureLead': 'Não conseguimos concluir o pagamento deste pedido.',
  'orderReturn.failureHint': 'O carrinho foi limpo ao fazer o pedido. Tente novamente, veja o pedido ou contacte o suporte.',
  'orderReturn.btnDetails': 'Ver detalhes do pedido',
  'orderReturn.btnSignIn': 'Entrar para ver os detalhes',
  'orderReturn.btnContinueShopping': 'Continuar a comprar',
  'orderReturn.btnContactSupport': 'Contactar suporte',
  'orderReturn.btnTryAgain': 'Tentar novamente',
  'confirm.loadFailed': 'Falha ao carregar os detalhes do pedido',
  'confirm.shippingAddress': 'Endereço de entrega',
  'confirm.edit': 'Editar',
  'confirm.paymentMethod': 'Forma de pagamento',
  'confirm.notSelected': 'Não selecionado',
  'confirm.shippingNote': '*O envio US2US costuma levar 3 dias úteis após o envio (até 5 dias úteis).',
  'confirm.overseasShippingNote': '*O envio overseas costuma levar 14-28 dias úteis para produtos da UE e da Índia.',
  'confirm.manufacturerNote': '*Temos vários fabricantes deste produto. Se o fabricante que você pediu estiver sem estoque, entraremos em contato e ofereceremos uma alternativa.',
  'confirm.agreePolicy': 'Declaro que concordo com a Política de reembolso e a Política de chargebacks',
  'confirm.back': 'Voltar',
  'confirm.placing': 'Enviando pedido...',
  'confirm.previewModeNotice': 'Modo de pré-visualização - pedidos reais estão desativados.',
  'confirm.success': 'Pedido realizado com sucesso!',
  'confirm.invalidResponse': 'Resposta de pedido inválida',
  'confirm.failed': 'Falha ao realizar o pedido',
  'qnr.loading': 'Carregando questionário...',
  'qnr.loadFailed': 'Falha ao carregar o questionário',
  'qnr.retry': 'Tentar novamente',
  'qnr.intro': 'Preencha este formulário para solicitar a receita do medicamento pedido. São as mesmas informações que seriam solicitadas em uma clínica ou por um médico.',
  'qnr.general': 'Informações gerais',
  'qnr.dob': 'Data de nascimento do paciente',
  'qnr.day': 'Dia',
  'qnr.month': 'Mês',
  'qnr.year': 'Ano',
  'qnr.dobRequired': 'A data de nascimento é obrigatória',
  'qnr.gender': 'Gênero',
  'qnr.selectPlaceholder': 'Selecionar...',
  'qnr.genderRequired': 'O gênero é obrigatório',
  'qnr.height': 'Altura do paciente',
  'qnr.heightRequired': 'A altura é obrigatória',
  'qnr.weight': 'Peso do paciente',
  'qnr.weightRequired': 'O peso é obrigatório',
  'qnr.medicalHistory': 'Histórico médico',
  'qnr.disorderQuestion': 'Qual é o distúrbio ou queixa para o qual você solicita este medicamento?',
  'qnr.conditionRequired': 'A condição médica é obrigatória',
  'qnr.otherDisease': 'Você tem alguma outra doença, distúrbio ou problema médico?',
  'qnr.yesNo': 'Responda sim ou não',
  'qnr.specifyOther': 'Se sim, especifique',
  'qnr.specifyRequired': 'Especifique outros problemas médicos',
  'qnr.confirmations': 'Confirmações',
  'qnr.declaration': 'Declaro que as informações fornecidas são completas e sem reservas...',
  'qnr.declarationRequired': 'A declaração é obrigatória',
  'qnr.responsibility': 'Declaração de responsabilidade do cliente',
  'qnr.responsibilityRequired': 'A declaração de responsabilidade é obrigatória',
  'qnr.consent': 'Declaro que concordo com o Acordo de consentimento informado',
  'qnr.consentRequired': 'O acordo de consentimento é obrigatório',
  'qnr.yes': 'Sim',
  'qnr.no': 'Não',
  'qnr.back': 'Voltar',
  'qnr.saving': 'Salvando...',
  'qnr.continue': 'Continuar',
  'qnr.saved': 'Questionário médico salvo',
  'qnr.saveFailed': 'Falha ao salvar o questionário',
  'validate.ccEmpty': 'O número do cartão não pode ficar vazio',
  'validate.ccInvalid': 'O número do cartão não é válido',
  'validate.ccAmex': 'O número do cartão Amex deve ser válido',
  'validate.ccMaster': 'O número do MasterCard deve ser válido',
  'validate.ccVisa': 'O número do Visa deve ser válido',
  'validate.ccTypeEmpty': 'O tipo de cartão não pode ficar vazio',
  'validate.cvvDigits': 'O CVV2 deve ter 3-4 dígitos',
  'validate.cvvEmpty': 'O CVV2 não pode ficar vazio',
  'validate.bankEmpty': 'O nome do banco não pode ficar vazio',
  'validate.bankLength': 'O nome do banco deve ter entre 1 e 32 caracteres',
  'validate.chequeEmpty': 'O número do cheque não pode ficar vazio',
  'validate.chequeDigits': 'O número do cheque deve conter apenas dígitos',
  'validate.chequeLength': 'O número do cheque deve ter entre 1 e 16 caracteres',
  'validate.routingEmpty': 'O número de roteamento não pode ficar vazio',
  'validate.routingDigits': 'O número de roteamento deve conter apenas dígitos',
  'validate.routingLength': 'O número de roteamento deve ter entre 1 e 16 caracteres',
  'validate.accountEmpty': 'O número da conta não pode ficar vazio',
  'validate.accountDigits': 'O número da conta deve conter apenas dígitos',
  'validate.accountLength': 'O número da conta deve ter entre 1 e 16 caracteres',
  'paymentMethod.credit_card_amex': 'Cartão de crédito (Amex)',
  'paymentMethod.credit_card': 'Cartão de crédito',
  'paymentMethod.echeque': 'Cheque eletrônico',
  'paymentMethod.bitcoin': 'Bitcoin',
  'paymentCard.amex': 'Amex',
  'paymentCard.mc': 'MasterCard',
  'paymentCard.visa': 'Visa',
  'orderSuccess.placedSuccess': 'O seu pedido foi realizado com sucesso.',
  'orderSuccess.thanks': 'Obrigado! O seu pedido foi realizado.',
  'orderSuccess.orderId': 'ID do pedido:',
  'orderSuccess.description': 'Você receberá uma confirmação do pedido por e-mail. Processaremos o seu pedido o mais rápido possível.',
  'orderSuccess.orderDetails': 'Detalhes do pedido',
  'orderSuccess.viewOrders': 'Ver meus pedidos',
  'orderSuccess.close': 'Voltar à loja',
  'pagination.label': 'Paginação',
  'pagination.first': 'Primeira',
  'pagination.previous': 'Anterior',
  'pagination.next': 'Próxima',
  'pagination.last': 'Última',

  // ── OrdersView (list/filter) ──
  'orders.loading': 'Carregando pedidos...',
  'orders.loadFailed': 'Falha ao carregar pedidos',
  'orders.empty': 'Ainda não há pedidos.',
  'orders.filter': 'Filtro:',
  'orders.allTime': 'Todo o período',
  'orders.thisMonth': 'Este mês',
  'orders.thisWeek': 'Esta semana',
  'orders.today': 'Hoje',

  // ── BonusAccountPage ──
  'referralProgram.headline': 'Convide um amigo: {friend}% para ele, {reward}% para você.',
  'referralProgram.intro': 'Partilhe o seu link pessoal. Depois de o seu amigo receber a primeira encomenda, aparecerá aqui um cupão separado de {reward}%.',
  'referralProgram.how': 'O seu amigo recebe {friend}% na primeira encomenda. Você recebe, após o envio, um cupão de {reward}% válido por {months} meses.',
  'referralProgram.rulesTitle': 'Regras dos cupões',
  'referralProgram.ruleSeparate': 'Recebe um cupão separado por cada novo cliente indicado.',
  'referralProgram.ruleOnePerOrder': 'Só pode ser aplicado um cupão por encomenda.',
  'referralProgram.ruleNoLimit': 'O desconto de {reward}% não tem limite máximo.',
  'referralProgram.couponsTitle': 'Os seus cupões de indicação',
  'referralProgram.noCoupons': 'Ainda não tem cupões de indicação.',
  'referralProgram.apply': 'Aplicar ao carrinho',
  'referralProgram.applying': 'A aplicar…',
  'referralProgram.expires': 'Expira',
  'referralProgram.status.active': 'Ativo',
  'referralProgram.status.redeemed': 'Utilizado',
  'referralProgram.status.expired': 'Expirado',
  'referralProgram.status.revoked': 'Indisponível',
  'referralShare.button': 'Partilhar',
  'referralShare.signIn': 'Inicie sessão ou crie uma conta para partilhar o seu link de indicação pessoal.',
  'referralShare.signInButton': 'Iniciar sessão para partilhar',
  'referralShare.copied': 'Link de indicação copiado.',
  'referralShare.failed': 'Não foi possível partilhar ou copiar o seu link de indicação.',
  'referralShare.ready': 'O seu link está pronto. Toque em Partilhar para o enviar.',
  'referralCoupon.loginRequired': 'Inicie sessão para aplicar o seu cupão de desconto.',
  'referralCoupon.applied': 'O seu cupão de {reward}% foi aplicado.',
  'referralCoupon.appliedGeneric': 'O seu cupão de desconto foi aplicado.',
  'referralCoupon.applyFailed': 'Não foi possível aplicar este cupão. Tente novamente na sua conta.',
  'bonus.headline': 'Ganhe bônus vitalícios com nosso programa de indicação',
  'bonus.intro': 'Convide amigos e ganhe bônus pelas compras deles. Você pode usar seu saldo de bônus para cobrir até 50% do seu próximo pedido.',
  'bonus.howTitle': 'Como funciona?',
  'bonus.howDesc': 'Compartilhe seu link ou código de indicação pessoal. Quando um novo cliente compra com ele, você recebe 15% do valor enviado como crédito de bônus.',
  'bonus.subsequent': 'Em cada pedido enviado futuro deles, você recebe mais 5%.',
  'bonus.friendBenefits': 'Quais são os benefícios para seu amigo?',
  'bonus.friendDiscount': 'Seu amigo recebe 20% de desconto no primeiro pedido usando seu link ou código.',
  'bonus.whyGreat': 'Por que isso é ótimo para você:',
  'bonus.benefit1': 'Use bônus para cobrir até 50% do total do pedido.',
  'bonus.benefit2': 'Seja notificado sempre que seu saldo de bônus for creditado.',
  'bonus.benefit3': 'Ganhe também com subindicações: 10% dos bônus que sua indicação direta receber.',
  'bonus.startSharing': 'Compartilhe seu link de indicação e comece a ganhar hoje.',
  'bonus.refLinkLabel': 'Seu link de indicação (clique para copiar)',
  'bonus.copy': 'Copiar para a área de transferência',
  'bonus.copied': 'Copiado',
  'bonus.copyFailed': 'Falha ao copiar',
  'bonus.refCodeIntro': 'Alternativamente, você pode compartilhar seu código único, que seus indicados podem usar como cupom.',
  'bonus.transactions': 'Transações da conta bônus',
  'bonus.referralTree': 'Árvore de indicações',

  // ── BonusTransactionsPage ──
  'bonusTx.loading': 'Carregando...',
  'bonusTx.back': 'Voltar',
  'bonusTx.balance': 'Conta bônus:',
  'bonusTx.date': 'Data',
  'bonusTx.addedBonus': 'Bônus adicionado',
  'bonusTx.usedBonus': 'Bônus usado',
  'bonusTx.type': 'Tipo',
  'bonusTx.empty': 'Ainda não há transações na sua conta bônus.',
  'bonusTx.typeM': 'Bônus de compra de indicação',
  'bonusTx.typeC': 'Bônus de compra de subindicação',
  'bonusTx.typeO': 'Bônus aplicado para pagar seu pedido',
  'bonusTx.typeOOrder': 'Bônus aplicado para pagar seu pedido nº {orderId}',
  'bonusTx.typeP': 'Presente',
  'bonusTx.typeW': 'Saque',

  // ── ReferralPage ──
  'referral.back': 'Voltar',
  'referral.loading': 'Carregando...',
  'referral.empty': 'Nenhum dado de indicação disponível.',
  'referral.description': 'Esta seção exibe a árvore de indicações a partir de você. Também mostra estatísticas de bônus de uma indicação específica e sua ramificação. Nosso sistema multinível permite ganhar 10% dos bônus de indicação das indicações feitas por suas indicações diretas.',
  'referral.referral': 'Indicação',
  'referral.bonuses': 'Bônus de indicação',
  'referral.subBonuses': 'Bônus de subindicação',
  'referral.level': 'nível:',
  'referral.bonusesNote': 'Bônus de indicação — bônus de compras feitas por suas indicações diretas.',
  'referral.subBonusesNote': 'Bônus de subindicação — bônus das indicações das suas indicações.',
};
